import React from 'react';
import { FormattedMessage, FormattedDate, injectIntl } from 'react-intl';
import styled from 'styled-components';
import { Row, Col } from 'antd';
import PropTypes from 'prop-types';
import { DownOutlined } from '@ant-design/icons';
import { media, Div } from 'ui';
import { withEllipsis } from 'ui/styles';
import Spinner from 'common/spinner/components/spinner';

const Bar = styled(Row)`
  background-color: ${p => p.theme.colors.orderStatusbar};
  box-shadow: 0px 5px 20px 3px gray;
  color: ${p => p.theme.colors.text};
  position: fixed;
  bottom: 0;
  left: 0;
  width: 100%;
  margin-left: 0 !important;
  margin-right: 0 !important;
  padding-left: 25px;
  height: 180px;
  ${media.tablet`height: 300px;`};
  border-top: 1px solid ${p => p.theme.colors.border};
  z-index: 1;

  > div:last-child {
    border: none;
  }
`;

const Column = styled(Col)`
  ${media.tablet`
    padding-top: 5px;
    padding-bottom: 5px;
  `}
  height: 100%;
`;

const OrderTitle = styled.div`
  font-size: 14px;
  color: #64747c;
  line-height: 25px;
`;

const InfoBlock = styled(Column)`
  border-right: 2px solid rgba(0, 149, 196, 0.24);
  padding-right: 8px !important;
  height: 100%;
  padding-top: 13px;
  font-size: 19px;
`;

const OrderInfoLine = styled.div`
  font-weight: ${p => p.theme.fontWeight.bold};
  color: ${p => p.theme.colors.text};
  line-height: 20px;
  ${withEllipsis};
`;

export const StateText = styled.div`
  color: ${p => p.theme.colors.alerts[p.severity]};
  font-weight: ${p => p.theme.fontWeight.bolder};
  font-size: 12px;
  line-height: 15px;
  text-transform: uppercase;

  > span {
    font-size: 12px;
  }
`;

const CollapseMessage = styled.div`
  text-decoration: underline;
  font-size: 12px;
  color: #64747c;
  cursor: pointer;
`;

const StyledIcon = styled(DownOutlined)`
  margin-left: 3px;
`;

const StatusBarMax = ({
  description,
  id,
  installedat,
  planneddate,
  progressinfo,
  hasmultipleorders,
  orderstates,
  activestatus,
  intl,
  statusses,
  minimize,
}) => {
  if (!orderstates || !activestatus || !orderstates.length) {
    return (
      <Bar type='flex' align='middle' gutter={16}>
        <InfoBlock sm={hasmultipleorders ? 21 : 2} xs={24}>
          <Spinner title={intl.formatMessage({ id: 'common.LOADING_STATUS' })} />
        </InfoBlock>
        {hasmultipleorders && <Column sm={3}>{progressinfo}</Column>}
      </Bar>
    );
  }

  return (
    <Bar type='flex' align='middle' gutter={16}>
      <InfoBlock sm={4} xs={24}>
        <CollapseMessage onClick={minimize}>
          <FormattedMessage id='order.MINIMIZE' />
          <StyledIcon type='down' />
        </CollapseMessage>
        <Div paddingTop={15}>
          <OrderTitle>
            <FormattedMessage id='order.currentOrder' />
          </OrderTitle>
          <OrderInfoLine>{description}</OrderInfoLine>
          <OrderInfoLine data-test-id='status-bar-max.sap-id'>
            {id && <FormattedMessage id='statusBar.SAP_ID' values={{ number: id }} />}
          </OrderInfoLine>
          <OrderInfoLine>{installedat}</OrderInfoLine>
          <OrderInfoLine>
            {planneddate &&
              <span>
                <FormattedMessage id='order.plannedDate' /> {': '}
                <FormattedDate value={planneddate} />
              </span>
            }
          </OrderInfoLine>
        </Div>
      </InfoBlock>
      <InfoBlock sm={hasmultipleorders ? 17 : 20} xs={24} data-test-id='status-bar-max.statuses'>
        {statusses}
      </InfoBlock>
      {hasmultipleorders && <Column sm={3}>{progressinfo}</Column>}
    </Bar>
  );
};

StatusBarMax.propTypes = {
  description: PropTypes.string,
  id: PropTypes.string,
  installedat: PropTypes.string,
  planneddate: PropTypes.string,
  activestatus: PropTypes.object,
  orderstates: PropTypes.array,
  progressinfo: PropTypes.object,
  hasmultipleorders: PropTypes.bool,
  intl: PropTypes.object,
  statusses: PropTypes.object,
  minimize: PropTypes.func,
};

export default injectIntl(StatusBarMax);
